// extracted by mini-css-extract-plugin
export default {"modal":"vla-z","header":"wla-z","fields":"xla-z","error":"yla-z","disabled":"zla-z","reminderMsg":"Ala-z","errorMsg":"Bla-z","footer":"Cla-z"};